export class GetAccessToken {
  static readonly type = '[Auth] Get Access Token';
  constructor(
    public app_key: string,
    public app_secret: string,
    public auth_code: string
  ) {}
}

export class GetAccessTokenSuccess {
  static readonly type = '[Auth] Get Access Token Success';
  constructor(public payload: any) {}
}

export class GetAccessTokenFailure {
  static readonly type = '[Auth] Get Access Token Failure';
  constructor(public error: any) {}
}
